import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Clickable,
  Icon,
  P,
  Tabs,
  Tooltip,
} from '@fashionnovateam/nova-ui-toolkit';
import { ItemLeadTimeFormValues } from '../../types';
import { EXCLUSIVITY_TOOLTIP } from '../../../../Lib/Constants/ui-text';

type ExclusivitySectionProps = {
  disabled?: boolean;
};

export function ExclusivitySection({ disabled }: ExclusivitySectionProps) {
  const { control, setValue, watch } = useFormContext<ItemLeadTimeFormValues>();
  const exclusivity = watch('exclusivity');

  const isExclusive =
    exclusivity === 'FN Exclusive' || exclusivity === 'Exclusive Going Forward';

  const handleSelectExclusive = () => {
    if (!disabled) {
      if (exclusivity === 'Exclusive Going Forward') {
        setValue('exclusivity', 'Exclusive Going Forward', {
          shouldDirty: false,
        });
      } else if (exclusivity === 'FN Exclusive') {
        setValue('exclusivity', 'FN Exclusive', { shouldDirty: false });
      } else {
        setValue('exclusivity', 'FN Exclusive', { shouldDirty: true });
      }
    }
  };

  const handleSelectNotExclusive = () => {
    if (!disabled) {
      setValue('exclusivity', 'Not Exclusive', { shouldDirty: true });
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1">
        <P size="sm" weight="medium" className="text-base-primary">
          FN Exclusive
        </P>
        <P size="sm" color="error">
          *
        </P>
        <Tooltip content={EXCLUSIVITY_TOOLTIP} position="top" arrow zIndex={60}>
          <Icon.InformationCircle className="text-neutral-400 cursor-help text-sm flex-shrink-0" />
        </Tooltip>
      </div>
      <Controller
        control={control}
        name="exclusivity"
        render={() => (
          <Tabs.Group type="segment">
            <Clickable onClick={handleSelectExclusive} disabled={disabled}>
              <Tabs.Item type="segment" isActive={isExclusive}>
                Exclusive
              </Tabs.Item>
            </Clickable>
            <Clickable onClick={handleSelectNotExclusive} disabled={disabled}>
              <Tabs.Item type="segment" isActive={!isExclusive}>
                Not Exclusive
              </Tabs.Item>
            </Clickable>
          </Tabs.Group>
        )}
      />
    </div>
  );
}
